import { render, staticRenderFns } from "./material-insight-report.vue?vue&type=template&id=c143fb5c&scoped=true"
import script from "./material-insight-report.vue?vue&type=script&setup=true&lang=js"
export * from "./material-insight-report.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-insight-report.vue?vue&type=style&index=0&id=c143fb5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c143fb5c",
  null
  
)

export default component.exports